// extracted by mini-css-extract-plugin
export default {"error":"IZMrMlXqGVO32gZBGtk2","message":"XSnPs2cEOtWo8AnwLgdO"};